<template>
	<div id="app">
		<Menu/>
		<router-view></router-view>		
        <Footer/>
	</div>
</template>

<script>
import Menu from "./components/Menu.vue";
import Footer from "./components/Footer.vue";

export default {
	name: 'App',
	components: {
		Menu, Footer
	},
	created: function(){        
		this.$store.dispatch('getConfigData')
		
		if(localStorage.getItem("_thrubits_token") !== null)
			this.$store.dispatch('validateUser')
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>